export default {
   namespaced: true,
   state: {
      // 页面信息信息
      activeName: 'phone',
   },
   actions: {
      /**
       * @description 设置用户数据
       * @param {Object} context
       * @param {*} info info
       */
      setActiveName({ state, dispatch }, activeName) {
         // store 赋值
         state.activeName = activeName
      },
   },
}
